import styles from 'components/projects/ClientAndProjectListRow.module.scss';
import type { TooltipPosition } from 'components/Tooltip';
import Tooltip from 'components/Tooltip';
import React from 'react';

const BudgetIsPendingWrap: React.FC<{
  children: React.ReactNode;
  isPending: boolean;
  style?: React.CSSProperties;
  tooltipPosition?: TooltipPosition;
  title?: string;
}> = ({ style, isPending, children, tooltipPosition, title }) => {
  if (isPending) {
    return (
      <Tooltip
        position={tooltipPosition}
        style={style}
        className={styles.pendingWrap}
        title={title ?? 'Budget is being calculated, please wait...'}
        data-testid="budget-progress-tooltip"
      >
        {children}
      </Tooltip>
    );
  }
  return <>{children}</>;
};

export default BudgetIsPendingWrap;
